import { render, staticRenderFns } from "./ModalEditarEvento.vue?vue&type=template&id=c1ddf8de&"
import script from "./ModalEditarEvento.vue?vue&type=script&lang=js&"
export * from "./ModalEditarEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports